/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var EyeDropperIcon = createIcon({
  name: 'EyeDropperIcon',
  height: 512,
  width: 512,
  svgPath: 'M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default EyeDropperIcon;